// ULTRA SMART SEARCH
// Combinazione delle migliori funzionalità di ricerca con interfaccia grafica moderna

(function() {
  'use strict';

  // ======= 🔧 UTILITIES RICERCA COMPLETA ======= //
  const SearchUtils = {
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    sanitizeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text || '';
      return div.innerHTML;
    },

    stripHtml(html) {
      const div = document.createElement('div');
      div.innerHTML = html || '';
      return div.textContent || div.innerText || '';
    },

    formatShopifyImageUrl(url, size = '400x400') {
      if (!url) return this.getPlaceholderImage();

      try {
        const baseUrl = url.split('?')[0];
        const extension = baseUrl.split('.').pop().toLowerCase();
        const basePath = baseUrl.replace(`.${extension}`, '');
        return `${basePath}_${size}.${extension}`;
      } catch (error) {
        return this.getPlaceholderImage();
      }
    },

    getPlaceholderImage() {
      return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200"%3E%3Crect width="200" height="200" fill="%23f8f9fa"/%3E%3Ctext x="50%25" y="45%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="12" fill="%23636e72"%3E🛍️%3C/text%3E%3Ctext x="50%25" y="55%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="10" fill="%23636e72"%3EProdotto%3C/text%3E%3C/svg%3E';
    },

    getCollectionPlaceholder() {
      return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200"%3E%3Crect width="200" height="200" fill="%234FC13E"/%3E%3Ctext x="50%25" y="45%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="12" fill="white"%3E📦%3C/text%3E%3Ctext x="50%25" y="55%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="10" fill="white"%3ECollezione%3C/text%3E%3C/svg%3E';
    },

    getPagePlaceholder() {
      return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200"%3E%3Crect width="200" height="200" fill="%236FD85E"/%3E%3Ctext x="50%25" y="45%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="12" fill="white"%3E📄%3C/text%3E%3Ctext x="50%25" y="55%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="10" fill="white"%3EPagina%3C/text%3E%3C/svg%3E';
    },

    getArticlePlaceholder() {
      return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200"%3E%3Crect width="200" height="200" fill="%23ff6b6b"/%3E%3Ctext x="50%25" y="45%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="12" fill="white"%3E📰%3C/text%3E%3Ctext x="50%25" y="55%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="10" fill="white"%3EArticolo%3C/text%3E%3C/svg%3E';
    },

    formatPrice(price, item) {
      const formattedPrice = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parseFloat(price) || 0);

      // Controlla se è un prodotto di piastrelle/ceramica
      let isTile = false;

      if (item) {
        // Controlla i tags (array di stringhe)
        if (item.tags && Array.isArray(item.tags)) {
          isTile = item.tags.some(tag =>
            tag.toLowerCase().includes('piastrelle') ||
            tag.toLowerCase().includes('ceramica') ||
            tag.toLowerCase().includes('gres') ||
            tag.toLowerCase().includes('tiles')
          );
        }

        // Se non trovato nei tags, controlla il product_type
        if (!isTile && item.product_type) {
          const productType = item.product_type.toLowerCase();
          isTile = productType.includes('piastrelle') ||
                  productType.includes('ceramica') ||
                  productType.includes('tiles') ||
                  productType.includes('gres');
        }

        // Se non trovato, controlla il vendor per CeramicaEuro o FormaAquae
        if (!isTile && item.vendor) {
          const vendor = item.vendor.toLowerCase();
          isTile = vendor.includes('ceramicaeuro') ||
                  vendor.includes('formaaquae') ||
                  vendor.includes('ceramica euro') ||
                  vendor.includes('forma aquae');
        }

        // Come ultimo controllo, verifica il titolo solo se contiene parole chiave specifiche
        if (!isTile && item.title) {
          const title = item.title.toLowerCase();
          isTile = (title.includes('piastrelle') || title.includes('gres porcellanato')) &&
                  !title.includes('accessori') &&
                  !title.includes('colla');
        }
      }

      if (isTile) {
        return formattedPrice + '<span style="font-size: 1em; color: inherit; font-weight: inherit;">/</span><span style="font-size: 0.9em; color: inherit;">mq</span>';
      } else {
        return formattedPrice + '';
      }
    },

    formatComparePrice(price) {
      // Mantieni esattamente la precisione del prezzo originale
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parseFloat(price) || 0);
    }
  };


  // Collections data loaded from inline Liquid script via window.shopifyCollections


  // ======= 📦 DATA MANAGER COMPLETO ======= //
  class CompleteDataManager {
    constructor() {
      this.products = [];
      this.collections = [];
      this.pages = [];
      this.articles = [];
      this.blogs = [];
      this.initialized = false;
      this.cache = new Map();
      this.isLoading = false;
    }

    async initialize() {
      if (this.isLoading) return;
      this.isLoading = true;

      try {

        // Carica tutto in parallelo per velocità
        await Promise.all([
          this.loadProducts(),
          this.loadCollections(),
          this.loadPages()
        ]);

        this.initialized = true;

      } catch (error) {
        this.loadDemoData();
        this.initialized = true;
      }

      this.isLoading = false;
    }

    async loadProducts() {
      let allProducts = [];
      let page = 1;
      const limit = 250;

      while (page <= 20) {
        try {
          const response = await fetch(`/products.json?limit=${limit}&page=${page}`);
          if (!response.ok) break;

          const data = await response.json();
          if (!data.products || data.products.length === 0) break;

          allProducts = allProducts.concat(data.products);
          page++;
        } catch (error) {
          break;
        }
      }

      this.products = allProducts;
    }

    async loadCollections() {
      try {
        // USA LE COLLEZIONI REALI DA SHOPIFY LIQUID
        // PERF: indice collezioni da endpoint esterno cache-abile (-262KB inline/pagina)
        try {
          var __CK = 'hu_search_collections_v1', __TTL = 86400000, __cached = null;
          try { var __raw = localStorage.getItem(__CK); if (__raw) { var __o = JSON.parse(__raw); if (__o && (Date.now() - __o.t) < __TTL && __o.d && __o.d.length) { __cached = __o.d; } } } catch (e) {}
          if (__cached && __cached.length > 0) {
            this.collections = __cached;
            window.shopifyCollections = __cached;
            fetch('/search?view=collections-data').then(function(r){return r.text();}).then(function(t){try{var d=JSON.parse(t); if(d&&d.length){localStorage.setItem(__CK, JSON.stringify({t:Date.now(), d:d}));}}catch(e){}}).catch(function(){});
            window.debugCollections = () => { return this.collections; };
            return;
          }
          var __resp = await fetch('/search?view=collections-data');
          var __txt = await __resp.text();
          var __data = JSON.parse(__txt);
          if (__data && __data.length > 0) {
            this.collections = __data;
            window.shopifyCollections = __data;
            try { localStorage.setItem(__CK, JSON.stringify({t:Date.now(), d:__data})); } catch (e) {}
            window.debugCollections = () => { return this.collections; };
            return;
          }
        } catch (e) { /* fallback sotto */ }
        // Fallback legacy: dati inline (se ancora presenti)
        if (window.shopifyCollections && window.shopifyCollections.length > 0) {
          this.collections = window.shopifyCollections;
          window.debugCollections = () => { return this.collections; };
          return;
        }

        // Fallback: carica da API solo se non abbiamo collezioni da Liquid
        const allCollections = [];

        try {
          const response = await fetch('/collections.json?limit=250');
          if (response.ok) {
            const data = await response.json();
            if (data.collections && data.collections.length > 0) {
              allCollections.push(...data.collections);
            }
          }
        } catch (e) {
        }

        // Filtra collezioni speciali
        const filteredCollections = allCollections.filter(c => {
          const handle = (c.handle || '').toLowerCase();
          return handle !== 'all' &&
                handle !== 'frontpage' &&
                handle !== 'all-products' &&
                handle !== 'tutti' &&
                handle !== 'tutti-i-prodotti';
        });

        this.collections = filteredCollections;
      } catch (error) {
        this.collections = [];
      }
    }

    async loadPages() {
      try {
        const response = await fetch('/pages.json');
        if (response.ok) {
          const data = await response.json();
          this.pages = data.pages || [];
        }
      } catch (error) {
      }
    }

    async loadBlogs() {
      try {
        const blogsResponse = await fetch('/blogs.json');
        if (blogsResponse.ok) {
          const blogsData = await blogsResponse.json();
          this.blogs = blogsData.blogs || [];

          for (const blog of this.blogs) {
            try {
              const articlesResponse = await fetch(`/blogs/${blog.handle}/articles.json`);
              if (articlesResponse.ok) {
                const articlesData = await articlesResponse.json();
                const articles = articlesData.articles || [];

                articles.forEach(article => {
                  article.blog_title = blog.title;
                  article.blog_handle = blog.handle;
                });

                this.articles = this.articles.concat(articles);
              }
            } catch (error) {
            }
          }
        }
      } catch (error) {
      }
    }

    loadDemoData() {
      this.products = [
        {
          id: 1,
          title: 'Divano moderno 3 posti grigio',
          handle: 'divano-moderno-grigio',
          vendor: 'ModernHome',
          product_type: 'Divani',
          tags: ['soggiorno', 'moderno', 'grigio'],
          variants: [{
            price: '899.00',
            compare_at_price: null,
            available: true
          }],
          images: [{ src: SearchUtils.getPlaceholderImage() }]
        },
        {
          id: 2,
          title: 'Tavolino da caffè in legno',
          handle: 'tavolino-caffe-legno',
          vendor: 'WoodCraft',
          product_type: 'Tavoli',
          tags: ['soggiorno', 'legno', 'classico'],
          variants: [{
            price: '299.00',
            available: true
          }],
          images: [{ src: SearchUtils.getPlaceholderImage() }]
        }
      ];

      this.collections = [
        {
          id: 1,
          title: 'Collezione Soggiorno',
          handle: 'soggiorno',
          description: 'Arredi per il soggiorno moderno',
          image: { src: SearchUtils.getCollectionPlaceholder() }
        }
      ];

      this.pages = [
        {
          id: 1,
          title: 'Chi Siamo',
          handle: 'chi-siamo',
          content: 'La nostra storia e i nostri valori'
        }
      ];

      this.articles = [
        {
          id: 1,
          title: 'Come arredare il soggiorno',
          handle: 'come-arredare-soggiorno',
          summary: 'Guida completa per arredare il soggiorno',
          blog_title: 'Blog Design',
          blog_handle: 'design'
        }
      ];
    }

    searchEverything(query, options = {}) {
      if (!this.initialized) return { results: [], totalFound: 0 };

      const cacheKey = `${query.toLowerCase()}_${JSON.stringify(options)}`;
      if (this.cache.has(cacheKey)) {
        return this.cache.get(cacheKey);
      }

      const results = this.performCompleteSearch(query, options);
      this.cache.set(cacheKey, results);

      return results;
    }

    performCompleteSearch(query, options = {}) {
      const { limit = 12 } = options;
      const queryLower = query.toLowerCase().trim();

      if (!queryLower) return { results: [], totalFound: 0 };

      let allResults = [];

      // Cerca nei prodotti
      const productResults = this.searchProducts(queryLower).map(item => ({
        ...item,
        type: 'product',
        icon: '🛍️',
        url: `/products/${item.handle}`,
        price: this.getProductMinPrice(item),
        image: this.getProductImage(item),
        description: item.product_type || 'Prodotto',
        variants: item.variants || []
      }));

      // Cerca nelle collezioni
      const collectionResults = this.searchCollections(queryLower).map(item => {
        const image = this.getCollectionImage(item);

        return {
          ...item,
          type: 'collection',
          icon: '📦',
          url: `/collections/${item.handle}`,
          image: image,
          description: item.description || 'Collezione'
        };
      });

      // Cerca nelle pagine
      const pageResults = this.searchPages(queryLower).map(item => ({
        ...item,
        type: 'page',
        icon: '📄',
        url: `/pages/${item.handle}`,
        image: SearchUtils.getPagePlaceholder(),
        description: 'Pagina'
      }));

      // Cerca negli articoli
      const articleResults = this.searchArticles(queryLower).map(item => ({
        ...item,
        type: 'article',
        icon: '📰',
        url: `/blogs/${item.blog_handle}/${item.handle}`,
        image: this.getArticleImage(item),
        description: item.blog_title || 'Articolo'
      }));

      // Combina tutti i risultati
      allResults = [
        ...productResults,
        ...collectionResults,
        ...pageResults,
        ...articleResults
      ];

      // Ordina per rilevanza
      allResults = allResults.sort((a, b) => {
        const aScore = this.calculateRelevanceScore(a, queryLower);
        const bScore = this.calculateRelevanceScore(b, queryLower);
        return bScore - aScore;
      });

      // Distribuisci equamente i risultati tra le categorie invece di tagliare tutto insieme
      let finalResults = [];
      const categoryLimits = {
        product: Math.ceil(limit * 0.4), // 40% per prodotti
        collection: Math.ceil(limit * 0.3), // 30% per collezioni
        page: Math.ceil(limit * 0.15), // 15% per pagine
        article: Math.ceil(limit * 0.15) // 15% per articoli
      };

      // Prendi i migliori risultati per ogni categoria
      const limitedProducts = productResults.slice(0, categoryLimits.product);
      const limitedCollections = collectionResults.slice(0, categoryLimits.collection);
      const limitedPages = pageResults.slice(0, categoryLimits.page);
      const limitedArticles = articleResults.slice(0, categoryLimits.article);

      // Combina i risultati limitati
      finalResults = [...limitedProducts, ...limitedCollections, ...limitedPages, ...limitedArticles];

      // Ordina di nuovo per rilevanza
      finalResults = finalResults.sort((a, b) => {
        const aScore = this.calculateRelevanceScore(a, queryLower);
        const bScore = this.calculateRelevanceScore(b, queryLower);
        return bScore - aScore;
      });

      // Limita al numero massimo richiesto nel caso ci siano meno risultati di alcune categorie
      finalResults = finalResults.slice(0, limit);

      return {
        results: finalResults,
        totalFound: allResults.length,
        breakdown: {
          products: productResults.length,
          collections: collectionResults.length,
          pages: pageResults.length,
          articles: articleResults.length
        }
      };
    }

    searchProducts(query) {
      return this.products.filter(product => {
        const searchText = [
          product.title || '',
          product.vendor || '',
          product.product_type || '',
          (product.tags || []).join(' ')
        ].join(' ').toLowerCase();

        return searchText.includes(query) ||
              query.split(' ').some(word => searchText.includes(word));
      });
    }

    searchCollections(query) {
      return this.collections.filter(collection => {
        // Prima controlla titolo e handle (come in search_updated.liquid)
        const titleLower = (collection.title || '').toLowerCase();
        const handleLower = (collection.handle || '').toLowerCase();

        // Se trova match diretto in titolo o handle, include la collezione
        if (titleLower.includes(query) || handleLower.includes(query)) {
          return true;
        }

        // Altrimenti cerca nei tag dei prodotti (ma solo match esatti del tag, non parziali)
        if (collection.productTags && Array.isArray(collection.productTags)) {
          for (let tag of collection.productTags) {
            if (tag) {
              const tagLower = tag.toLowerCase();
              // Match esatto del tag o il tag contiene la query completa
              if (tagLower === query || tagLower.includes(query)) {
                return true;
              }
            }
          }
        }

        return false;
      });
    }

    searchPages(query) {
      return this.pages.filter(page => {
        const searchText = [
          page.title || '',
          SearchUtils.stripHtml(page.content || ''),
          page.handle || ''
        ].join(' ').toLowerCase();

        return searchText.includes(query) ||
              query.split(' ').some(word => searchText.includes(word));
      });
    }

    searchArticles(query) {
      return this.articles.filter(article => {
        const searchText = [
          article.title || '',
          article.summary || '',
          SearchUtils.stripHtml(article.content || ''),
          article.blog_title || '',
          (article.tags || []).join(' ')
        ].join(' ').toLowerCase();

        return searchText.includes(query) ||
              query.split(' ').some(word => searchText.includes(word));
      });
    }

    calculateRelevanceScore(item, query) {
      let score = 0;
      const title = item.title.toLowerCase();

      if (title === query) score += 1000;
      if (title.includes(query)) score += 500;

      switch(item.type) {
        case 'product': score += 100; break;
        case 'collection': score += 80; break;
        case 'page': score += 60; break;
        case 'article': score += 40; break;
      }

      query.split(' ').forEach(word => {
        if (title.includes(word)) score += 50;
      });

      return score;
    }

    getProductMinPrice(product) {
      // 🎯 PRIMA: Prova sempre a ottenere prezzo Shopify come fallback sicuro
      let shopifyPrice = 0;

      // Helper: converte prezzo Shopify (stringa "45.00" o numero)
      // Shopify REST API /products.json restituisce prezzi come stringhe decimali (es. "45.00")
      // NON in centesimi come l'API Ajax
      const parseShopifyPrice = (val) => {
        if (!val) return 0;
        const num = parseFloat(val);
        return isNaN(num) ? 0 : num;
      };

      // Metodo 1: Cerca nelle varianti (formato stringa "45.00")
      if (product.variants && product.variants.length > 0) {
        for (const v of product.variants) {
          const vp = parseShopifyPrice(v.price);
          if (vp > 0 && (shopifyPrice === 0 || vp < shopifyPrice)) {
            shopifyPrice = vp;
          }
        }
      }

      // Metodo 2: price_min (può essere in centesimi o euro a seconda del contesto)
      if (shopifyPrice === 0 && product.price_min) {
        let pm = parseFloat(product.price_min) || 0;
        // Se è intero e molto grande rispetto a prezzi realistici, probabilmente è in centesimi
        // Un prezzo > 10000 cents = €100 è comune, ma > 100000 cents = €1000 è raro in centesimi
        if (pm > 0 && Number.isInteger(pm) && pm > 100) {
          pm = pm / 100;
        }
        shopifyPrice = pm;
      }

      // Metodo 3: Campo price diretto
      if (shopifyPrice === 0 && product.price) {
        shopifyPrice = parseShopifyPrice(product.price);
      }

      // Metodo 4: price_range (alcuni temi usano questo)
      if (shopifyPrice === 0 && product.price_range && product.price_range.min) {
        shopifyPrice = parseShopifyPrice(product.price_range.min);
      }

      // 🎯 SOLO per PIASTRELLE: prova prezzi fissi (sovrascrive Shopify se trovato)
      try {
        // Se ha formato nel titolo, prova getPrezzoFissoM2
        if (typeof window.getPrezzoFissoM2 === 'function' && product.title) {
          const formatMatch = product.title.match(/(\d+)\s*x\s*(\d+)/i);
          if (formatMatch) {
            const formato = formatMatch[0].replace(/\s+/g, '').toLowerCase();
            const prezziFissi = window.getPrezzoFissoM2(formato, product.title);
            if (prezziFissi) {
              return prezziFissi.prezzo; // Già in euro, NON dividere per 100
            }
          }
        }
        // Se prodotto è in SUPERGRES_PRODUCTS, usa prezzo minimo m²
        if (typeof window.getMinPrezzoM2Prodotto === 'function' && product.title) {
          const minPrezzo = window.getMinPrezzoM2Prodotto(product.title);
          if (minPrezzo) {
            return minPrezzo.prezzo; // Già in euro, NON dividere per 100
          }
        }
      } catch (e) { /* Ignora errori prezzi-fissi, usa Shopify */ }

      // Ritorna prezzo Shopify (già calcolato sopra)
      return shopifyPrice;
    }

    getProductImage(product) {
      if (!product.images || product.images.length === 0) {
        return SearchUtils.getPlaceholderImage();
      }
      return SearchUtils.formatShopifyImageUrl(product.images[0].src, '200x200');
    }

    getCollectionImage(collection) {
      // Prova prima l'immagine principale
      if (collection.image) {
        if (typeof collection.image === 'string' && collection.image !== 'null') {
          return SearchUtils.formatShopifyImageUrl(collection.image, '200x200');
        }
        if (collection.image.src) {
          return SearchUtils.formatShopifyImageUrl(collection.image.src, '200x200');
        }
      }

      // Prova featured_image come fallback
      if (collection.featured_image) {
        if (typeof collection.featured_image === 'string' && collection.featured_image !== 'null') {
          return SearchUtils.formatShopifyImageUrl(collection.featured_image, '200x200');
        }
        if (collection.featured_image.src) {
          return SearchUtils.formatShopifyImageUrl(collection.featured_image.src, '200x200');
        }
      }

      // Se non c'è immagine, usa placeholder
      return SearchUtils.getCollectionPlaceholder();
    }

    getArticleImage(article) {
      if (article.image) {
        if (typeof article.image === 'string') {
          return SearchUtils.formatShopifyImageUrl(article.image, '200x200');
        }
        if (article.image.src) {
          return SearchUtils.formatShopifyImageUrl(article.image.src, '200x200');
        }
      }
      return SearchUtils.getArticlePlaceholder();
    }
  }

  // ======= 🎨 PREMIUM SEARCH UI MANAGER ======= //
  class PremiumSearchUI {
    constructor(dataManager) {
      this.dataManager = dataManager;
      this.createMobileModal();
      this.createDesktopInterface();
      this.setupEventListeners();
    }

    createMobileModal() {
      // Crea il modale mobile con grafica premium
      const modalHTML = `
        <div class="ultra-mobile-search-modal" id="ultraMobileSearchModal">
          <div class="ultra-mobile-search-modal-overlay"></div>
          <div class="ultra-mobile-search-modal-content">
            <!-- Header della modale -->
            <div class="ultra-mobile-search-modal-header">
              <div class="ultra-mobile-search-modal-title">
                <!-- Rimosso icona lente e testo -->
              </div>
              <button class="ultra-mobile-search-modal-close" aria-label="Chiudi ricerca">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>

            <!-- Input di ricerca -->
            <div class="ultra-mobile-search-modal-input-container">
              <div class="ultra-mobile-search-modal-input-wrapper">
                <svg class="ultra-mobile-search-modal-input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <input type="text" class="ultra-mobile-search-modal-input" placeholder="Cerca prodotti, collezioni, pagine..." autocomplete="off" autocorrect="off" spellcheck="false">
                <button class="ultra-mobile-search-modal-clear" style="display: none;" aria-label="Cancella">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.1"/>
                    <path d="M15 9L9 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 9L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Risultati della ricerca -->
            <div class="ultra-mobile-search-modal-results">
              <!-- Loader -->
              <div class="ultra-mobile-search-modal-loader" style="display: none;">
                <div class="ultra-mobile-search-loader-spinner"></div>
                <p>Ricerca completa in corso...</p>
                <div class="ultra-search-loader-dots">
                  <span></span><span></span><span></span>
                </div>
              </div>

              <!-- Stato iniziale -->
              <div class="ultra-mobile-search-modal-initial">
                <div class="ultra-mobile-search-initial-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.3"/>
                    <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.3"/>
                  </svg>
                </div>
                <h3>Ricerca Ultra Smart</h3>
                <p>Trova tutto in HomeUp:</p>
                <div class="ultra-search-features">
                  <div class="ultra-search-feature">
                    <span class="ultra-search-feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
                        <line x1="7" y1="7" x2="7.01" y2="7"/>
                      </svg>
                    </span>
                    <span>Prodotti</span>
                  </div>
                  <div class="ultra-search-feature">
                    <span class="ultra-search-feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="3" width="7" height="7"/>
                        <rect x="14" y="3" width="7" height="7"/>
                        <rect x="14" y="14" width="7" height="7"/>
                        <rect x="3" y="14" width="7" height="7"/>
                      </svg>
                    </span>
                    <span>Collezioni</span>
                  </div>
                  <div class="ultra-search-feature">
                    <span class="ultra-search-feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                        <polyline points="14 2 14 8 20 8"/>
                        <line x1="16" y1="13" x2="8" y2="13"/>
                        <line x1="16" y1="17" x2="8" y2="17"/>
                      </svg>
                    </span>
                    <span>Pagine</span>
                  </div>
                  <div class="ultra-search-feature">
                    <span class="ultra-search-feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H8a2 2 0 00-2 2v16a2 2 0 01-2 2zm0 0a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h2"/>
                        <path d="M18 14h-8M18 10h-8M10 6h8"/>
                      </svg>
                    </span>
                    <span>Articoli</span>
                  </div>
                </div>
              </div>

              <!-- Risultati -->
              <div class="ultra-mobile-search-modal-results-content" style="display: none;">
                <div class="ultra-mobile-search-modal-results-header">
                  <span class="ultra-mobile-search-results-count">0 risultati</span>
                </div>

                <div class="ultra-mobile-search-modal-tabs">
                  <button class="ultra-mobile-search-modal-tab active" data-tab="all">
                    <span>Tutti</span>
                    <span class="ultra-mobile-tab-count">0</span>
                  </button>
                  <button class="ultra-mobile-search-modal-tab" data-tab="products">
                    <span>Prodotti</span>
                    <span class="ultra-mobile-tab-count">0</span>
                  </button>
                  <button class="ultra-mobile-search-modal-tab" data-tab="collections">
                    <span>Collezioni</span>
                    <span class="ultra-mobile-tab-count">0</span>
                  </button>
                  <button class="ultra-mobile-search-modal-tab" data-tab="other">
                    <span>Altro</span>
                    <span class="ultra-mobile-tab-count">0</span>
                  </button>
                </div>

                <div class="ultra-mobile-search-modal-results-grid">
                  <div id="ultra-mobile-all-results" class="ultra-mobile-search-tab-content active"></div>
                  <div id="ultra-mobile-products-results" class="ultra-mobile-search-tab-content"></div>
                  <div id="ultra-mobile-collections-results" class="ultra-mobile-search-tab-content"></div>
                  <div id="ultra-mobile-other-results" class="ultra-mobile-search-tab-content"></div>
                </div>

                <div class="ultra-mobile-search-modal-footer">
                  <a href="#" class="ultra-mobile-search-view-all-btn">
                    <span>Vedi tutti i risultati</span>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>

              <!-- Nessun risultato -->
              <div class="ultra-mobile-search-modal-empty" style="display: none;">
                <div class="ultra-mobile-search-empty-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.3"/>
                    <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.3"/>
                    <path d="M8 11L14 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.3"/>
                  </svg>
                </div>
                <h3>Nessun risultato trovato</h3>
                <p>Prova con termini diversi o controlla l'ortografia</p>
              </div>
            </div>
          </div>
        </div>
      `;

      document.body.insertAdjacentHTML('beforeend', modalHTML);
      this.addModalStyles();
    }

    createDesktopInterface() {
      // Potenzia gli input esistenti
      const searchInputs = document.querySelectorAll(
        'input[type="search"], .search-input, #searchInput, [name="q"], .header-search input, .search-form input, input[placeholder*="search" i], input[placeholder*="cerca" i]'
      );

      searchInputs.forEach(input => {
        if (!input.dataset.ultraEnhanced) {
          this.enhanceDesktopInput(input);
          input.dataset.ultraEnhanced = 'true';
        }
      });
    }

    enhanceDesktopInput(input) {
      const container = this.createDesktopDropdown();
      this.positionDropdown(input, container);

      const debouncedSearch = SearchUtils.debounce(
        (query) => this.performDesktopSearch(query, container),
        200
      );

      input.addEventListener('input', (e) => {
        const query = e.target.value.trim();
        if (query.length >= 2) {
          debouncedSearch(query);
          this.showDesktopDropdown(container);
        } else {
          this.hideDesktopDropdown(container);
        }
      });

      input.addEventListener('focus', () => {
        if (input.value.length >= 2) {
          this.showDesktopDropdown(container);
        }
      });

      input.addEventListener('blur', () => {
        setTimeout(() => {
          if (!container.contains(document.activeElement)) {
            this.hideDesktopDropdown(container);
          }
        }, 200);
      });
    }

    createDesktopDropdown() {
      const dropdown = document.createElement('div');
      dropdown.className = 'ultra-desktop-search-dropdown';
      dropdown.innerHTML = `
        <div class="ultra-desktop-search-content">
          <div class="ultra-desktop-search-loading">
            <div class="ultra-desktop-loading-spinner"></div>
            <span>Ricerca in corso...</span>
          </div>
        </div>
      `;
      return dropdown;
    }

    positionDropdown(input, dropdown) {
      const parent = input.parentElement;
      if (getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      parent.appendChild(dropdown);
    }

    showDesktopDropdown(dropdown) {
      dropdown.style.display = 'block';
      setTimeout(() => dropdown.classList.add('active'), 10);
    }

    hideDesktopDropdown(dropdown) {
      dropdown.classList.remove('active');
      setTimeout(() => dropdown.style.display = 'none', 300);
    }

    performDesktopSearch(query, dropdown) {
      const content = dropdown.querySelector('.ultra-desktop-search-content');
      content.innerHTML = `
        <div class="ultra-desktop-search-loading">
          <div class="ultra-desktop-loading-spinner"></div>
          <span>Ricerca in corso...</span>
        </div>
      `;

      const results = this.dataManager.searchEverything(query, { limit: 8 });
      content.innerHTML = this.buildDesktopResults(results, query);
    }

    buildDesktopResults(searchResults, query) {
      if (searchResults.totalFound === 0) {
        return `
          <div class="ultra-desktop-search-empty">
            <div class="ultra-desktop-empty-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
            </div>
            <div class="ultra-desktop-empty-text">Nessun risultato per "${SearchUtils.sanitizeHtml(query)}"</div>
          </div>
        `;
      }

      // Calcola i contatori come in search_updated.liquid
      const queryLower = query.toLowerCase().trim();

      // Conta tutti i prodotti che matchano
      const matchingProducts = this.dataManager.products.filter(product => {
        const searchText = [
          product.title || '',
          product.vendor || '',
          product.product_type || '',
          (product.tags || []).join(' ')
        ].join(' ').toLowerCase();

        return searchText.includes(queryLower) ||
              queryLower.split(' ').some(word => searchText.includes(word));
      });

      // Conta tutte le collezioni che matchano - USA IL METODO MIGLIORATO
      const matchingCollections = this.dataManager.searchCollections(queryLower);

      // Conta pagine e articoli
      const matchingPages = this.dataManager.pages.filter(page => {
        const searchText = [
          page.title || '',
          SearchUtils.stripHtml(page.content || ''),
          page.handle || ''
        ].join(' ').toLowerCase();

        return searchText.includes(queryLower) ||
              queryLower.split(' ').some(word => searchText.includes(word));
      });

      const matchingArticles = this.dataManager.articles ? this.dataManager.articles.filter(article => {
        const searchText = [
          article.title || '',
          SearchUtils.stripHtml(article.content || ''),
          article.tags ? article.tags.join(' ') : ''
        ].join(' ').toLowerCase();

        return searchText.includes(queryLower) ||
              queryLower.split(' ').some(word => searchText.includes(word));
      }) : [];

      // Calcola i totali
      const totalProducts = matchingProducts.length;
      const totalCollections = matchingCollections.length;
      const totalPages = matchingPages.length;
      const totalArticles = matchingArticles.length;
      const totalOthers = totalPages + totalArticles;
      const totalResults = totalProducts + totalCollections + totalOthers;

      // Prendi solo i primi risultati da mostrare nel dropdown
      const allResults = searchResults.results;
      const productResults = allResults.filter(item => item.type === 'product').slice(0, 8);
      const collectionResults = allResults.filter(item => item.type === 'collection').slice(0, 8);
      const otherResults = allResults.filter(item => item.type !== 'product' && item.type !== 'collection').slice(0, 8);


      let html = `
        <div class="ultra-desktop-search-header">
          <div class="ultra-desktop-search-title">
            <span class="ultra-desktop-search-count">${totalResults} risultati</span>
            <span class="ultra-desktop-search-query">per "${SearchUtils.sanitizeHtml(query)}"</span>
          </div>
        </div>

        <!-- Tabs Desktop come in search_updated.liquid -->
        <div class="ultra-desktop-search-tabs">
          <button class="ultra-desktop-search-tab active" data-tab="all">
            <span>Tutti</span>
            <span class="ultra-desktop-tab-count">${totalResults}</span>
          </button>
          <button class="ultra-desktop-search-tab" data-tab="products">
            <span>Prodotti</span>
            <span class="ultra-desktop-tab-count">${totalProducts}</span>
          </button>
          <button class="ultra-desktop-search-tab" data-tab="collections">
            <span>Collezioni</span>
            <span class="ultra-desktop-tab-count">${totalCollections}</span>
          </button>
          <button class="ultra-desktop-search-tab" data-tab="other">
            <span>Altro</span>
            <span class="ultra-desktop-tab-count">${totalOthers}</span>
          </button>
        </div>

        <!-- Tab Contents -->
        <div class="ultra-desktop-search-results">
          <!-- All Results -->
          <div class="ultra-desktop-tab-content active" data-content="all">
      `;

      allResults.forEach(item => {
        html += this.buildDesktopResultItem(item);
      });

      html += `
          </div>

          <!-- Products Only -->
          <div class="ultra-desktop-tab-content" data-content="products">
      `;

      if (productResults.length > 0) {
        productResults.forEach(item => {
          html += this.buildDesktopResultItem(item);
        });
      } else {
        html += '<div class="ultra-desktop-no-results">Nessun prodotto trovato</div>';
      }

      html += `
          </div>

          <!-- Collections Only -->
          <div class="ultra-desktop-tab-content" data-content="collections">
      `;

      if (collectionResults.length > 0) {
        collectionResults.forEach(item => {
          html += this.buildDesktopResultItem(item);
        });
      } else {
        html += '<div class="ultra-desktop-no-results">Nessuna collezione trovata</div>';
      }

      html += `
          </div>

          <!-- Other (Pages & Articles) -->
          <div class="ultra-desktop-tab-content" data-content="other">
      `;

      if (otherResults.length > 0) {
        otherResults.forEach(item => {
          html += this.buildDesktopResultItem(item);
        });
      } else {
        html += '<div class="ultra-desktop-no-results">Nessuna pagina o articolo trovato</div>';
      }

      html += `
          </div>
        </div>

        <div class="ultra-desktop-search-footer">
          <a href="${window.theme.routes.search_url}?q=${encodeURIComponent(query)}" class="ultra-desktop-search-view-all">
            <span>Vedi tutti i ${searchResults.totalFound} risultati</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      `;

      // Aggiungi event listener per i tab dopo il rendering
      setTimeout(() => {
        this.setupDesktopTabs();
      }, 10);

      return html;
    }

    buildDesktopResultItem(item) {
      let priceInfo = '';

      if (item.type === 'product' && item.price > 0) {
        // 🎯 Usa getPrezzoMinimoM2 per prezzo e compare dal worker (già in euro)
        const calculatedPrice = window.getPrezzoMinimoM2 ? window.getPrezzoMinimoM2(item.title) : null;
        const currentPrice = (calculatedPrice && calculatedPrice.prezzo) ? (calculatedPrice.prezzo / 100) : item.price;
        const comparePrice = (calculatedPrice && calculatedPrice.comparePrice) ? (calculatedPrice.comparePrice / 100) : this.getComparePrice(item);
        const hasDiscount = comparePrice > currentPrice;
        const discountPercentage = hasDiscount ? Math.round(((comparePrice - currentPrice) / comparePrice) * 100) : 0;

        // 🛡️ PROTEZIONE: Salva compare price come data-attribute per proteggere da interferenze
        const dataAttrs = comparePrice > 0 ? `data-shopify-compare="${comparePrice}"` : '';

        if (hasDiscount) {
          priceInfo = `
            <div class="ultra-desktop-item-price-container" ${dataAttrs}>
              <div class="ultra-desktop-price-main">
                ${item.variants && item.variants.length > 1 ? '<span class="ultra-desktop-price-label">A PARTIRE DA</span>' : ''}
                <span class="ultra-desktop-price-current">${SearchUtils.formatPrice(currentPrice, item)}</span>
                <span class="ultra-desktop-price-compare" data-original-shopify="true">${SearchUtils.formatComparePrice(comparePrice)}</span>
                
              </div>
            </div>
          `;
        } else {
          priceInfo = `
            <div class="ultra-desktop-item-price-container" ${dataAttrs}>
              <div class="ultra-desktop-price-main">
                ${item.variants && item.variants.length > 1 ? '<span class="ultra-desktop-price-label">A PARTIRE DA</span>' : ''}
                <span class="ultra-desktop-price-current">${SearchUtils.formatPrice(currentPrice, item)}</span>
              </div>
            </div>
          `;
        }
      }

      const isAvailable = item.type === 'product' ?
        (item.variants && item.variants.some(v => v.available)) : true;

      const statusInfo = item.type !== 'product' ?
        `<span class="ultra-desktop-item-badge type-${item.type}">
          ${item.type === 'collection' ?
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline; vertical-align: middle; margin-right: 4px;"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> COLLEZIONE' :
            item.type === 'page' ?
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline; vertical-align: middle; margin-right: 4px;"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg> PAGINA' :
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline; vertical-align: middle; margin-right: 4px;"><path d="M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H8a2 2 0 00-2 2v16a2 2 0 01-2 2zm0 0a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8M18 10h-8M10 6h8"/></svg> ARTICOLO'
          }
        </span>` : '';

      // Aggiungi data-price-updated se il prezzo è stato calcolato
      const priceAttr = priceInfo ? 'data-price-updated="true"' : '';

      return `
        <a href="${item.url}" class="ultra-desktop-search-item" ${priceAttr}>
          <div class="ultra-desktop-item-title">${SearchUtils.sanitizeHtml(item.title)}</div>
          <div class="ultra-desktop-item-wrapper">
            <div class="ultra-desktop-item-image">
              <img src="${item.image}" alt="${SearchUtils.sanitizeHtml(item.title)}"
                  style="object-fit: ${item.type === 'collection' ? 'contain' : 'cover'};"
                  onerror="this.src='${SearchUtils.getPlaceholderImage()}'">
            </div>
            <div class="ultra-desktop-item-content">
              ${priceInfo}
            </div>
          </div>
          ${statusInfo ? `<div class="ultra-desktop-item-status">${statusInfo}</div>` : ''}
        </a>
      `;
    }

    setupDesktopTabs() {
      const desktopTabs = document.querySelectorAll('.ultra-desktop-search-tab');
      const desktopContents = document.querySelectorAll('.ultra-desktop-tab-content');

      desktopTabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const tabType = tab.dataset.tab;

          // Rimuovi active da tutti i tab
          desktopTabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          // Nascondi tutti i contenuti
          desktopContents.forEach(content => content.classList.remove('active'));

          // Mostra il contenuto corrispondente
          const targetContent = document.querySelector(`.ultra-desktop-tab-content[data-content="${tabType}"]`);
          if (targetContent) {
            targetContent.classList.add('active');
          }
        });
      });
    }

    setupEventListeners() {
      // Mobile modal
      const mobileModal = document.getElementById('ultraMobileSearchModal');
      const mobileClose = mobileModal?.querySelector('.ultra-mobile-search-modal-close');
      const mobileOverlay = mobileModal?.querySelector('.ultra-mobile-search-modal-overlay');
      const mobileInput = mobileModal?.querySelector('.ultra-mobile-search-modal-input');
      const mobileClear = mobileModal?.querySelector('.ultra-mobile-search-modal-clear');
      const mobileTabs = mobileModal?.querySelectorAll('.ultra-mobile-search-modal-tab');

      // Apertura modale mobile
      document.addEventListener('click', (e) => {
        if (e.target.matches('.search-icon-mobile, .search-icon-mobile *, [data-action="mobile-search"], [data-action="mobile-search"] *')) {
          this.openMobileModal();
        }
      });

      // Chiusura modale mobile
      mobileClose?.addEventListener('click', () => this.closeMobileModal());
      mobileOverlay?.addEventListener('click', () => this.closeMobileModal());

      // Input mobile con debounce
      const debouncedMobileSearch = SearchUtils.debounce(
        (query) => this.performMobileSearch(query),
        200
      );
      mobileInput?.addEventListener('input', (e) => {
        const query = e.target.value.trim();
        if (mobileClear) {
          mobileClear.style.display = query ? 'block' : 'none';
        }

        if (query.length >= 2) {
          debouncedMobileSearch(query);
        } else {
          this.showMobileInitialState();
        }
      });

      // Clear mobile
      mobileClear?.addEventListener('click', () => {
        if (mobileInput) {
          mobileInput.value = '';
          mobileClear.style.display = 'none';
          this.showMobileInitialState();
        }
      });

      // Tabs mobile
      mobileTabs?.forEach(tab => {
        tab.addEventListener('click', () => {
          const tabType = tab.dataset.tab;

          mobileTabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          const allContents = mobileModal.querySelectorAll('.ultra-mobile-search-tab-content');
          allContents.forEach(content => content.classList.remove('active'));

          const targetContent = document.getElementById(`ultra-mobile-${tabType}-results`);
          if (targetContent) {
            targetContent.classList.add('active');
          }
        });
      });

      // Chiusura con ESC
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileModal?.classList.contains('active')) {
          this.closeMobileModal();
        }
      });
    }

    openMobileModal() {
      const modal = document.getElementById('ultraMobileSearchModal');
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
          const input = modal.querySelector('.ultra-mobile-search-modal-input');
          if (input) input.focus();
        }, 500);
      }
    }

    closeMobileModal() {
      const modal = document.getElementById('ultraMobileSearchModal');
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';

        const input = modal.querySelector('.ultra-mobile-search-modal-input');
        if (input) {
          input.value = '';
          input.dispatchEvent(new Event('input'));
        }

        this.showMobileInitialState();
      }
    }

    showMobileInitialState() {
      const modal = document.getElementById('ultraMobileSearchModal');
      if (!modal) return;

      // Reset contatori nei tab
      modal.querySelectorAll('.ultra-mobile-tab-count').forEach(counter => {
        counter.textContent = '0';
      });

      const states = {
        initial: modal.querySelector('.ultra-mobile-search-modal-initial'),
        loader: modal.querySelector('.ultra-mobile-search-modal-loader'),
        results: modal.querySelector('.ultra-mobile-search-modal-results-content'),
        empty: modal.querySelector('.ultra-mobile-search-modal-empty')
      };

      Object.keys(states).forEach(key => {
        if (states[key]) {
          states[key].style.display = key === 'initial' ? 'flex' : 'none';
        }
      });
    }

    showMobileLoader() {
      const modal = document.getElementById('ultraMobileSearchModal');
      if (!modal) return;

      const states = {
        initial: modal.querySelector('.ultra-mobile-search-modal-initial'),
        loader: modal.querySelector('.ultra-mobile-search-modal-loader'),
        results: modal.querySelector('.ultra-mobile-search-modal-results-content'),
        empty: modal.querySelector('.ultra-mobile-search-modal-empty')
      };

      Object.keys(states).forEach(key => {
        if (states[key]) {
          states[key].style.display = key === 'loader' ? 'flex' : 'none';
        }
      });
    }

    showMobileResults() {
      const modal = document.getElementById('ultraMobileSearchModal');
      if (!modal) return;

      const states = {
        initial: modal.querySelector('.ultra-mobile-search-modal-initial'),
        loader: modal.querySelector('.ultra-mobile-search-modal-loader'),
        results: modal.querySelector('.ultra-mobile-search-modal-results-content'),
        empty: modal.querySelector('.ultra-mobile-search-modal-empty')
      };

      Object.keys(states).forEach(key => {
        if (states[key]) {
          states[key].style.display = key === 'results' ? 'block' : 'none';
        }
      });
    }

    showMobileEmpty() {
      const modal = document.getElementById('ultraMobileSearchModal');
      if (!modal) return;

      // Reset contatori nei tab
      modal.querySelectorAll('.ultra-mobile-tab-count').forEach(counter => {
        counter.textContent = '0';
      });

      const states = {
        initial: modal.querySelector('.ultra-mobile-search-modal-initial'),
        loader: modal.querySelector('.ultra-mobile-search-modal-loader'),
        results: modal.querySelector('.ultra-mobile-search-modal-results-content'),
        empty: modal.querySelector('.ultra-mobile-search-modal-empty')
      };

      Object.keys(states).forEach(key => {
        if (states[key]) {
          states[key].style.display = key === 'empty' ? 'flex' : 'none';
        }
      });
    }

    performMobileSearch(query) {
      this.showMobileLoader();

      const results = this.dataManager.searchEverything(query, { limit: 12 });

      if (results.totalFound === 0) {
        this.showMobileEmpty();
        return;
      }

      this.updateMobileResults(results, query);
      this.showMobileResults();
    }

    updateMobileResults(results, query) {
      const modal = document.getElementById('ultraMobileSearchModal');
      if (!modal) return;

      // Calcola i contatori come in search_updated.liquid
      const queryLower = query.toLowerCase().trim();

      // Conta tutti i prodotti che matchano
      const matchingProducts = this.dataManager.products.filter(product => {
        const searchText = [
          product.title || '',
          product.vendor || '',
          product.product_type || '',
          (product.tags || []).join(' ')
        ].join(' ').toLowerCase();

        return searchText.includes(queryLower) ||
              queryLower.split(' ').some(word => searchText.includes(word));
      });

      // Conta tutte le collezioni che matchano - USA IL METODO MIGLIORATO
      const matchingCollections = this.dataManager.searchCollections(queryLower);

      // Conta pagine
      const matchingPages = this.dataManager.pages.filter(page => {
        const searchText = [
          page.title || '',
          SearchUtils.stripHtml(page.content || ''),
          page.handle || ''
        ].join(' ').toLowerCase();

        return searchText.includes(queryLower) ||
              queryLower.split(' ').some(word => searchText.includes(word));
      });

      // Conta articoli
      const matchingArticles = this.dataManager.articles ? this.dataManager.articles.filter(article => {
        const searchText = [
          article.title || '',
          SearchUtils.stripHtml(article.content || ''),
          article.tags ? article.tags.join(' ') : ''
        ].join(' ').toLowerCase();

        return searchText.includes(queryLower) ||
              queryLower.split(' ').some(word => searchText.includes(word));
      }) : [];

      // Calcola i totali
      const totalProducts = matchingProducts.length;
      const totalCollections = matchingCollections.length;
      const totalPages = matchingPages.length;
      const totalArticles = matchingArticles.length;
      const totalOthers = totalPages + totalArticles;
      const totalResults = totalProducts + totalCollections + totalOthers;

      // Aggiorna counter
      const counter = modal.querySelector('.ultra-mobile-search-results-count');
      if (counter) {
        counter.textContent = `${totalResults} risultat${totalResults !== 1 ? 'i' : 'o'}`;
      }

      // Aggiorna breakdown
      const breakdown = {
        'products': totalProducts,
        'collections': totalCollections,
        'pages': totalPages,
        'articles': totalArticles
      };

      ['products', 'collections', 'pages', 'articles'].forEach(type => {
        const element = modal.querySelector(`[data-type="${type}"]`);
        if (element) {
          element.textContent = breakdown[type] || 0;
        }
      });

      // Aggiorna view all button
      const viewAllBtn = modal.querySelector('.ultra-mobile-search-view-all-btn');
      if (viewAllBtn) {
        viewAllBtn.href = `${window.theme.routes.search_url}?q=${encodeURIComponent(query)}`;
      }

      // Genera risultati per tab (limitati per il display)
      const allResults = results.results.slice(0, 12);
      const productResults = allResults.filter(item => item.type === 'product');
      const collectionResults = allResults.filter(item => item.type === 'collection');
      const otherResults = allResults.filter(item => item.type !== 'product' && item.type !== 'collection');

      // Aggiorna i contatori nei tab con i totali reali
      const tabCounts = {
        'all': totalResults,
        'products': totalProducts,
        'collections': totalCollections,
        'other': totalOthers
      };

      Object.keys(tabCounts).forEach(tabType => {
        const tabButton = modal.querySelector(`.ultra-mobile-search-modal-tab[data-tab="${tabType}"] .ultra-mobile-tab-count`);
        if (tabButton) {
          tabButton.textContent = tabCounts[tabType];
        }
      });

      // Aggiorna contenuti (mostra solo i primi risultati per performance)
      this.updateMobileTabContent('ultra-mobile-all-results', allResults);
      this.updateMobileTabContent('ultra-mobile-products-results', productResults);
      this.updateMobileTabContent('ultra-mobile-collections-results', collectionResults);
      this.updateMobileTabContent('ultra-mobile-other-results', otherResults);
    }

    updateMobileTabContent(containerId, results) {
      const container = document.getElementById(containerId);
      if (!container) return;

      if (results.length === 0) {
        container.innerHTML = `
          <div class="ultra-mobile-search-no-results">
            <div class="ultra-mobile-no-results-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
            </div>
            <div class="ultra-mobile-no-results-text">Nessun risultato in questa categoria</div>
          </div>
        `;
        return;
      }

      let html = '';
      results.forEach((item, index) => {
        html += this.buildMobileResultItem(item, index);
      });

      container.innerHTML = html;
    }

    getComparePrice(item) {
      // Helper: converte prezzo Shopify (stringa "45.00" o numero)
      const parseShopifyPrice = (val) => {
        if (!val) return 0;
        const num = parseFloat(val);
        return isNaN(num) ? 0 : num;
      };

      // 🎯 PRIMA: Calcola compare price Shopify come fallback sicuro
      let shopifyCompare = 0;
      if (item.variants && item.variants.length > 0) {
        for (const v of item.variants) {
          const cp = parseShopifyPrice(v.compare_at_price);
          if (cp > 0 && (shopifyCompare === 0 || cp < shopifyCompare)) {
            shopifyCompare = cp;
          }
        }
      }
      if (shopifyCompare === 0 && item.compare_at_price) {
        shopifyCompare = parseShopifyPrice(item.compare_at_price);
      }

      // 🎯 COMPARE PRICE: USA SEMPRE SHOPIFY (non prezzi-fissi)
      // Il prezzo vendita usa prezzi-fissi, ma il compare price viene da Shopify
      // Se abbiamo un compare price Shopify, usalo (ritorna in EURO per compatibilità con formatPrice)
      if (shopifyCompare > 0) {
        return shopifyCompare; // Ritorna in EURO
      }

      // 🎯 FALLBACK FINALE: Per prodotti con varianti, trova il prezzo di confronto più basso valido
      if (item.variants && item.variants.length > 0) {
        const validComparePrices = item.variants
          .filter(variant => variant.compare_at_price && parseShopifyPrice(variant.compare_at_price) > parseShopifyPrice(variant.price))
          .map(variant => parseShopifyPrice(variant.compare_at_price));

        if (validComparePrices.length > 0) {
          return Math.min(...validComparePrices); // Ritorna in EURO
        }
      }

      // Usa compare_at_price_min se disponibile
      if (item.compare_at_price_min && parseShopifyPrice(item.compare_at_price_min) > parseShopifyPrice(item.price || 0)) {
        return parseShopifyPrice(item.compare_at_price_min); // Ritorna in EURO
      }

      // Fallback agli altri campi
      if (item.compare_at_price && parseShopifyPrice(item.compare_at_price) > parseShopifyPrice(item.price || 0)) {
        return parseShopifyPrice(item.compare_at_price); // Ritorna in EURO
      }

      if (item.compare_at_price_max && parseShopifyPrice(item.compare_at_price_max) > parseShopifyPrice(item.price || 0)) {
        return parseShopifyPrice(item.compare_at_price_max); // Ritorna in EURO
      }

      return 0;
    }

    buildMobileResultItem(item, index) {
      let priceInfo = '';

      if (item.type === 'product' && item.price > 0) {
        // 🎯 Usa getPrezzoMinimoM2 per prezzo e compare dal worker (già in euro)
        const calculatedPrice = window.getPrezzoMinimoM2 ? window.getPrezzoMinimoM2(item.title) : null;
        const currentPrice = (calculatedPrice && calculatedPrice.prezzo) ? (calculatedPrice.prezzo / 100) : item.price;
        const comparePrice = (calculatedPrice && calculatedPrice.comparePrice) ? (calculatedPrice.comparePrice / 100) : this.getComparePrice(item);
        const hasDiscount = comparePrice > currentPrice;
        const discountPercentage = hasDiscount ? Math.round(((comparePrice - currentPrice) / comparePrice) * 100) : 0;

        // 🛡️ PROTEZIONE: Salva compare price come data-attribute per proteggere da interferenze
        const dataAttrs = comparePrice > 0 ? `data-shopify-compare="${comparePrice}"` : '';

        if (hasDiscount) {
          priceInfo = `
            <div class="ultra-mobile-item-price-container" ${dataAttrs}>
              ${item.variants && item.variants.length > 1 ? '<div class="ultra-mobile-price-label">A PARTIRE DA</div>' : ''}
              <div class="ultra-mobile-price-main">
                <span class="ultra-mobile-price-current">${SearchUtils.formatPrice(currentPrice, item)}</span>
                <span class="ultra-mobile-price-compare" data-original-shopify="true">${SearchUtils.formatComparePrice(comparePrice)}</span>
              </div>
              <div class="ultra-mobile-price-discount"></div>
            </div>
          `;
        } else {
          priceInfo = `
            <div class="ultra-mobile-item-price-container" ${dataAttrs}>
              ${item.variants && item.variants.length > 1 ? '<div class="ultra-mobile-price-label">A PARTIRE DA</div>' : ''}
              <div class="ultra-mobile-price-current">${SearchUtils.formatPrice(currentPrice, item)}</div>
            </div>
          `;
        }
      }

      const isAvailable = item.type === 'product' ?
        (item.variants && item.variants.some(v => v.available)) : true;

      const statusBadge = item.type !== 'product' ?
        `<span class="ultra-mobile-item-badge type-${item.type}">
          ${item.type === 'collection' ?
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline; vertical-align: middle; margin-right: 4px;"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> COLLEZIONE' :
            item.type === 'page' ?
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline; vertical-align: middle; margin-right: 4px;"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg> PAGINA' :
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline; vertical-align: middle; margin-right: 4px;"><path d="M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H8a2 2 0 00-2 2v16a2 2 0 01-2 2zm0 0a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8M18 10h-8M10 6h8"/></svg> ARTICOLO'
          }
        </span>` : '';

      // Aggiungi data-price-updated se il prezzo è stato calcolato
      const priceAttr = priceInfo ? 'data-price-updated="true"' : '';

      return `
        <a href="${item.url}" class="ultra-mobile-search-item" ${priceAttr} style="animation-delay: ${index * 0.1}s;">
          <div class="ultra-mobile-item-title">${SearchUtils.sanitizeHtml(item.title)}</div>
          <div class="ultra-mobile-item-wrapper">
            <div class="ultra-mobile-item-image">
              <img src="${item.image}" alt="${SearchUtils.sanitizeHtml(item.title)}"
                  style="object-fit: ${item.type === 'collection' ? 'contain' : 'cover'};"
                  onerror="this.src='${SearchUtils.getPlaceholderImage()}'">
            </div>
            <div class="ultra-mobile-item-content">
              ${priceInfo}
            </div>
          </div>
          ${statusBadge ? `<div class="ultra-mobile-item-status">${statusBadge}</div>` : ''}
        </a>
      `;
    }

    addModalStyles() {
      const styles = `
        <style>
          /* ======= ULTRA MOBILE SEARCH MODAL STYLES ======= */
          .ultra-mobile-search-modal {
            position: fixed;top: 0;left: 0;width: 100%;height: 100%;z-index: 99999;opacity: 0;visibility: hidden;transition: all 0.4s cubic-bezier(0.22,1,0.36,1);pointer-events: none;}

          .ultra-mobile-search-modal.active {
            opacity: 1;visibility: visible;pointer-events: auto;}

          .ultra-mobile-search-modal-overlay {
            position: absolute;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,0.7);backdrop-filter: blur(12px);-webkit-backdrop-filter: blur(12px);transition: all 0.4s ease;}

          .ultra-mobile-search-modal-content {
            position: relative;width: 100%;height: 100%;background: white;transform: translateY(100%);transition: transform 0.5s cubic-bezier(0.22,1,0.36,1);display: flex;flex-direction: column;overflow: hidden;}

          .ultra-mobile-search-modal.active .ultra-mobile-search-modal-content {
            transform: translateY(0);}

          /* Header */
          .ultra-mobile-search-modal-header {
            display: flex;align-items: center;justify-content: flex-end;padding: 10px 15px;border-bottom: 1px solid #D9D2C5;background: white !important;position: relative;box-shadow: 0 2px 8px rgba(0,0,0,0.02);min-height: 60px;}

          .ultra-mobile-search-modal-title {
            display: flex;align-items: center;font-size: 18px;font-weight: 600;font-family: 'Jost',sans-serif;color: #2c3e50 !important;}

          .ultra-search-modal-icon {
            margin-right: 10px;color: #2D5A3D !important;}

          .ultra-mobile-search-modal-close {
            width: 40px;height: 40px;border-radius: 50%;background: #F5F2EB !important;border: 1px solid #D9D2C5;display: flex;align-items: center;justify-content: center;color: #6c757d !important;transition: all 0.3s ease;cursor: pointer;}

          .ultra-mobile-search-modal-close:hover {
            background: #D9D2C5 !important;color: #495057 !important;transform: scale(1.05);}

          /* Input */
          .ultra-mobile-search-modal-input-container {
            padding: 15px 20px;background: white;border-bottom: 1px solid #D9D2C5;}

          .ultra-mobile-search-modal-input-wrapper {
            position: relative;display: flex;align-items: center;}

          .ultra-mobile-search-modal-input-icon {
            position: absolute;left: 15px;color: #2D5A3D;z-index: 2;}

          .ultra-mobile-search-modal-input {
            width: 100%;height: 50px;background: white;border: 2px solid #D9D2C5;border-radius: 25px;padding: 0 50px 0 45px;font-family: 'Jost',sans-serif;font-size: 16px;color: #2c3e50;box-shadow: 0 2px 8px rgba(0,0,0,0.03);transition: all 0.3s ease;font-weight: 500;}

          .ultra-mobile-search-modal-input:focus {
            outline: none;border-color: #2D5A3D;box-shadow: 0 0 0 3px rgba(45, 90, 61,0.1);transform: translateY(-2px);}

          .ultra-mobile-search-modal-input::placeholder {
            color: #6c757d;opacity: 0.7;}

          .ultra-mobile-search-modal-clear {
            position: absolute;right: 15px;width: 24px;height: 24px;border: none;background: transparent;color: #6c757d;cursor: pointer;z-index: 2;}

          /* Results container */
          .ultra-mobile-search-modal-results {
            flex: 1;overflow-y: auto;background: white;scrollbar-width: thin;scrollbar-color: #2D5A3D rgba(45, 90, 61,0.1);}

          .ultra-mobile-search-modal-results::-webkit-scrollbar {
            width: 4px;}

          .ultra-mobile-search-modal-results::-webkit-scrollbar-track {
            background: rgba(45, 90, 61,0.1);border-radius: 10px;}

          .ultra-mobile-search-modal-results::-webkit-scrollbar-thumb {
            background: #2D5A3D !important;border-radius: 10px;}

          .ultra-mobile-search-modal-results::-webkit-scrollbar-thumb:hover {
            background: #1B4332 !important;}

          /* Loader */
          .ultra-mobile-search-modal-loader {
            display: flex;flex-direction: column;align-items: center;justify-content: center;padding: 60px 20px;color: #2c3e50;}

          .ultra-mobile-search-loader-spinner {
            width: 40px;height: 40px;border: 3px solid rgba(45, 90, 61,0.1);border-top-color: #2D5A3D;border-radius: 50%;animation: ultra-mobile-spin 1s linear infinite;margin-bottom: 15px;}

          @keyframes ultra-mobile-spin {
            to { transform: rotate(360deg);}
          }

          .ultra-search-loader-dots {
            display: flex;gap: 4px;margin-top: 10px;}

          .ultra-search-loader-dots span {
            width: 6px;height: 6px;border-radius: 50%;background: #2D5A3D;animation: ultra-loader-dots 1.4s infinite both;}

          .ultra-search-loader-dots span:nth-child(1) { animation-delay: -0.32s;}
          .ultra-search-loader-dots span:nth-child(2) { animation-delay: -0.16s;}
          .ultra-search-loader-dots span:nth-child(3) { animation-delay: 0s;}

          @keyframes ultra-loader-dots {
            0%,80%,100% { transform: scale(0);}
            40% { transform: scale(1);}
          }

          /* Initial state */
          .ultra-mobile-search-modal-initial {
            display: flex;flex-direction: column;align-items: center;justify-content: center;padding: 80px 40px;text-align: center;color: #2c3e50;}

          .ultra-mobile-search-initial-icon {
            margin-bottom: 20px;color: #2D5A3D;}

          .ultra-mobile-search-modal-initial h3 {
            margin: 0 0 10px;font-size: 20px;font-weight: 600;font-family: 'Jost',sans-serif;}

          .ultra-mobile-search-modal-initial p {
            margin: 0 0 30px;font-size: 14px;opacity: 0.7;line-height: 1.5;}

          .ultra-search-features {
            display: grid;grid-template-columns: repeat(2,1fr);gap: 15px;width: 100%;max-width: 250px;}

          .ultra-search-feature {
            display: flex;flex-direction: column;align-items: center;padding: 15px;background: white;border-radius: 12px;border: 2px solid #2D5A3D;transition: all 0.3s ease;}

          .ultra-search-feature:hover {
            transform: translateY(-2px);box-shadow: 0 4px 12px rgba(45, 90, 61,0.3);border-color: #1B4332;}

          .ultra-search-feature-icon {
            display: flex;justify-content: center;align-items: center;margin-bottom: 8px;color: #2D5A3D;}

          .ultra-search-feature-icon svg {
            width: 28px;height: 28px;stroke: #2D5A3D;}

          .ultra-desktop-empty-icon svg,.ultra-mobile-no-results-icon svg {
            stroke: #6c757d;opacity: 0.5;}

          .ultra-desktop-item-badge svg,.ultra-mobile-item-badge svg {
            width: 14px;height: 14px;display: inline-block;vertical-align: middle;margin-right: 4px;}

          .ultra-search-feature span:last-child {
            font-size: 12px;font-weight: 600;color: #000000;}

          /* Results header */
          .ultra-mobile-search-modal-results-header {
            padding: 15px 20px;border-bottom: 1px solid #D9D2C5;background: #F5F2EB;}

          .ultra-mobile-search-results-count {
            font-size: 16px;font-weight: 600;color: #2c3e50 !important;font-family: 'Jost',sans-serif;margin-bottom: 10px;display: block;}

          .ultra-mobile-search-results-breakdown {
            display: flex;gap: 15px;flex-wrap: wrap;}

          .ultra-breakdown-item {
            display: flex;align-items: center;gap: 4px;font-size: 12px;color: #6c757d;}

          .ultra-breakdown-icon {
            font-size: 14px;}

          .ultra-breakdown-count {
            font-weight: 600;background: #F5F2EB;color: #495057;padding: 2px 6px;border-radius: 10px;border: 1px solid #D9D2C5;}

          /* Tabs */
          .ultra-mobile-search-modal-tabs {
            display: flex;background: white;border-bottom: 1px solid #D9D2C5;overflow-x: auto;scrollbar-width: none;-ms-overflow-style: none;}

          .ultra-mobile-search-modal-tabs::-webkit-scrollbar {
            display: none;}

          .ultra-mobile-search-modal-tab {
            flex: 1;min-width: 80px;padding: 12px 10px;background: none;border: none;font-size: 14px;font-weight: 500;color: #6c757d;position: relative;cursor: pointer;transition: all 0.3s ease;font-family: 'Jost',sans-serif;display: flex;align-items: center;justify-content: center;gap: 6px;}

          .ultra-mobile-tab-count {
            background: #F5F2EB;color: #6c757d;padding: 2px 4px;border-radius: 50%;font-size: 11px;font-weight: 700;min-width: 20px;height: 20px;display: inline-flex;align-items: center;justify-content: center;text-align: center;}

          .ultra-mobile-search-modal-tab.active .ultra-mobile-tab-count {
            background: #2D5A3D;color: white;}

          .ultra-mobile-search-modal-tab::after {
            content: '';position: absolute;bottom: 0;left: 0;width: 100%;height: 2px;background: #2D5A3D;transform: scaleX(0);transition: transform 0.3s ease;}

          .ultra-mobile-search-modal-tab.active {
            color: #2D5A3D;}

          .ultra-mobile-search-modal-tab.active::after {
            transform: scaleX(1);}

          /* Tab content */
          .ultra-mobile-search-modal-results-grid {
            flex: 1;overflow-y: auto;}

          .ultra-mobile-search-tab-content {
            padding: 15px 20px;display: none;}

          .ultra-mobile-search-tab-content.active {
            display: block;}

          /* Search items */
          .ultra-mobile-search-item {
            display: flex;flex-direction: column;padding: 0;border-radius: 12px;margin-bottom: 10px;background: white;box-shadow: 0 2px 8px rgba(0,0,0,0.04);transition: all 0.3s ease;text-decoration: none;color: inherit;border: 1px solid transparent;opacity: 0;transform: translateY(20px);animation: ultra-slide-in 0.4s ease forwards;overflow: hidden;}

          .ultra-mobile-item-wrapper {
            display: flex;align-items: center;padding: 0;background: white;}

          @keyframes ultra-slide-in {
            to {
              opacity: 1;transform: translateY(0);}
          }

          .ultra-mobile-search-item:hover {
            transform: translateY(-2px);box-shadow: 0 4px 12px rgba(45, 90, 61,0.15);border-color: #2D5A3D;}

          .ultra-mobile-item-image {
            width: 90px;height: 90px;border-radius: 10px;overflow: hidden;flex-shrink: 0;background: white;border: 1px solid #D9D2C5;position: relative;display: flex;align-items: center;justify-content: center;margin: 15px;margin-right: 0;}

          .ultra-mobile-item-image img {
            width: 100%;height: 100%;transition: transform 0.3s ease;}

          .ultra-mobile-item-image img[style*="contain"] {
            object-fit: contain !important;max-width: 100%;max-height: 100%;width: 100%;height: 100%;margin: auto;}

          .ultra-mobile-search-item:hover .ultra-mobile-item-image img {
            transform: scale(1.1);}

          .ultra-mobile-item-type-icon {
            position: absolute;top: 4px;right: 4px;font-size: 12px;}

          .ultra-mobile-item-content {
            flex: 1;display: flex;flex-direction: column;justify-content: center;align-items: center;text-align: center;background: white;padding: 15px;min-height: 120px;}

          .ultra-mobile-item-title {
            font-size: 14px;font-weight: 600;margin: 0;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;text-overflow: ellipsis;line-height: 1.3;max-height: 2.6em;font-family: 'Jost',sans-serif;color: #2c3e50;padding: 10px 15px;background: white;border-bottom: 1px solid rgba(0,0,0,0.08);text-align: left;}

          .ultra-mobile-item-status {
            padding: 10px 15px;background: white;border-top: 1px solid rgba(0,0,0,0.08);display: flex;align-items: center;text-align: left;}

          .ultra-mobile-item-type {
            font-size: 11px;font-weight: 600;color: #2c3e50;margin-bottom: 5px;font-family: 'Jost',sans-serif;}

          .ultra-mobile-item-price {
            font-size: 15px;font-weight: 700;color: #2D5A3D;margin-bottom: 5px;font-family: 'Jost',sans-serif;}

          /* New mobile price styling */
          .ultra-mobile-item-price-container {
            margin-bottom: 5px;background: #F5F2EB;border-radius: 12px;padding: 0.5rem;border: 1px solid rgba(224,224,224,0.5);width: 100%;}

          .ultra-mobile-price-label {
            display: inline-block;font-size: 0.55rem;color: #2e7d32;font-weight: 700;margin-bottom: 0.25rem;text-transform: uppercase;letter-spacing: 0.3px;background: #e8f5e9;padding: 0.2rem 0.45rem;border-radius: 20px;border: none;font-family: 'Jost',sans-serif;}

          .ultra-mobile-price-main {
            display: flex;align-items: center;justify-content: center;gap: 8px;margin-bottom: 3px;flex-wrap: nowrap;white-space: nowrap;}

          .ultra-mobile-price-current {
            font-size: 17px;font-weight: 800;color: #2D5A3D;font-family: 'Jost',sans-serif;white-space: nowrap;display: inline-block;position: relative;}

          .ultra-mobile-price-compare {
            font-size: 13px;color: #b2bec3;text-decoration: line-through;font-weight: 500;white-space: nowrap;}

          .ultra-mobile-price-discount {
            background: #E12D2D;color: white;font-size: 10px;padding: 3px 8px;border-radius: 8px;font-weight: 700;text-transform: uppercase;letter-spacing: 0.5px;display: inline-block;min-width: 85px;text-align: center;white-space: nowrap;}

          .ultra-mobile-item-badge {
            display: inline-block;padding: 3px 8px;font-size: 10px;border-radius: 12px;font-weight: 600;text-transform: uppercase;letter-spacing: 0.3px;background: #2D5A3D;color: white;min-width: 85px;text-align: center;white-space: nowrap;}

          .ultra-mobile-item-badge.available {
            background: #2D5A3D;color: white;}

          .ultra-mobile-item-badge.unavailable {
            background: #dc3545;color: white;}

          .ultra-mobile-item-badge.type-collection {
            background: #2D5A3D;color: white;}

          .ultra-mobile-item-badge.type-page {
            background: #2D5A3D;color: white;}

          .ultra-mobile-item-badge.type-article {
            background: #2D5A3D;color: white;}

          /* Footer */
          .ultra-mobile-search-modal-footer {
            padding: 15px 20px;border-top: 1px solid #D9D2C5;background: white;display: flex;justify-content: center;align-items: center;}

          .ultra-mobile-search-view-all-btn {
            display: inline-flex !important;align-items: center;justify-content: center;gap: 0.75rem;width: auto;max-width: 280px;padding: 0.875rem 2rem !important;background: white !important;color: #2D5A3D !important;border: 2px solid #2D5A3D !important;border-radius: 20px !important;text-decoration: none !important;font-family: 'Jost',-apple-system,BlinkMacSystemFont,sans-serif !important;font-weight: 600 !important;font-size: 16px !important;transition: all 0.3s cubic-bezier(0.4,0,0.2,1) !important;box-shadow: 0 2px 10px rgba(45, 90, 61,0.1) !important;text-align: center;}

          .ultra-mobile-search-view-all-btn:hover {
            background: #2D5A3D !important;color: white !important;transform: translateY(-2px) !important;box-shadow: 0 4px 15px rgba(45, 90, 61,0.25) !important;}

          .ultra-mobile-search-view-all-btn svg {
            width: 20px;height: 20px;stroke: currentColor;flex-shrink: 0;}

          /* Media query per assicurarsi che funzioni su mobile */
          @media (max-width: 768px) {
            .ultra-mobile-search-view-all-btn {
              display: inline-flex !important;background: white !important;color: #2D5A3D !important;border: 2px solid #2D5A3D !important;}

            .ultra-mobile-search-view-all-btn:active,.ultra-mobile-search-view-all-btn:focus {
              background: #2D5A3D !important;color: white !important;}
          }

          /* Media query per desktop - forza gli stessi stili */
          @media (min-width: 769px) {
            .ultra-mobile-search-view-all-btn {
              display: inline-flex !important;align-items: center !important;justify-content: center !important;gap: 0.75rem !important;width: auto !important;max-width: 280px !important;padding: 0.875rem 2rem !important;background: white !important;color: #2D5A3D !important;border: 2px solid #2D5A3D !important;border-radius: 20px !important;text-decoration: none !important;font-family: 'Jost',-apple-system,BlinkMacSystemFont,sans-serif !important;font-weight: 600 !important;font-size: 16px !important;transition: all 0.3s cubic-bezier(0.4,0,0.2,1) !important;box-shadow: 0 2px 10px rgba(45, 90, 61,0.1) !important;text-align: center !important;}

            .ultra-mobile-search-view-all-btn:hover {
              background: #2D5A3D !important;color: white !important;transform: translateY(-2px) !important;box-shadow: 0 4px 15px rgba(45, 90, 61,0.25) !important;}

            .ultra-mobile-search-modal-footer {
              display: flex !important;justify-content: center !important;align-items: center !important;}
          }

          /* Empty state */
          .ultra-mobile-search-modal-empty {
            display: flex;flex-direction: column;align-items: center;justify-content: center;padding: 60px 40px;text-align: center;color: #2c3e50;}

          .ultra-mobile-search-empty-icon {
            margin-bottom: 20px;color: #2D5A3D;opacity: 0.5;}

          .ultra-mobile-search-modal-empty h3 {
            margin: 0 0 10px;font-size: 18px;font-weight: 600;font-family: 'Jost',sans-serif;}

          .ultra-mobile-search-modal-empty p {
            margin: 0 0 20px;font-size: 14px;opacity: 0.7;line-height: 1.5;}

          /* No results in tab */
          .ultra-mobile-search-no-results {
            display: flex;flex-direction: column;align-items: center;justify-content: center;padding: 40px 20px;text-align: center;}

          .ultra-mobile-no-results-icon {
            font-size: 32px;margin-bottom: 10px;opacity: 0.5;}

          .ultra-mobile-no-results-text {
            font-size: 14px;color: #6c757d;font-family: 'Jost',sans-serif;}

          /* ======= ULTRA DESKTOP SEARCH DROPDOWN STYLES ======= */

          /* Fix per sovrascrittura prezzi e testi - Selettori più specifici */
          .ultra-desktop-search-dropdown .ultra-desktop-item-title {
            font-weight: 600 !important;font-family: 'Jost',sans-serif !important;}

          .ultra-desktop-search-dropdown .ultra-desktop-item-type {
            font-weight: 600 !important;color: #2c3e50 !important;}

          .ultra-desktop-search-dropdown .ultra-desktop-item-price-container .ultra-desktop-price-current {
            font-size: 20px !important;font-weight: 800 !important;color: #2D5A3D !important;font-family: 'Jost',sans-serif !important;}

          .ultra-desktop-search-dropdown .ultra-desktop-item-price-container .ultra-desktop-price-compare {
            font-size: 16px !important;color: #b2bec3 !important;text-decoration: line-through !important;font-weight: 500 !important;}

          .ultra-desktop-search-dropdown .ultra-desktop-item-price-container .ultra-desktop-price-discount {
            background: #E12D2D !important;color: white !important;font-size: 11px !important;padding: 4px 8px 4px 14px !important;border-radius: 0 3px 3px 0 !important;clip-path: polygon(8px 0,100% 0,100% 100%,8px 100%,0 50%) !important;-webkit-clip-path: polygon(8px 0,100% 0,100% 100%,8px 100%,0 50%) !important;-webkit-mask: radial-gradient(circle 3.5px at 6px 50%,transparent 75%,rgba(0,0,0,0.2) 85%,rgba(0,0,0,0.6) 92%,black 100%) 85%,rgba(0,0,0,0.6) 92%,black 100%) 96%,black 100%) !important;mask: radial-gradient(circle 3.5px at 6px 50%,transparent 75%,rgba(0,0,0,0.2) 85%,rgba(0,0,0,0.6) 92%,black 100%) 96%,black 100%) !important;font-weight: 700 !important;text-transform: uppercase !important;letter-spacing: 0.5px !important;display: inline-block !important;}
          .ultra-desktop-search-dropdown {
            position: absolute;top: calc(100% + 8px);left: 0;right: 0;background: white;border: 1px solid #D9D2C5;border-radius: 16px 0 0 16px;box-shadow: 0 8px 32px rgba(0,0,0,0.1);max-height: 500px;overflow-y: auto;opacity: 0;visibility: hidden;transform: translateY(-10px);transition: all 0.3s cubic-bezier(0.4,0,0.2,1);z-index: 9999;display: none;scrollbar-width: thin;scrollbar-color: #2D5A3D rgba(45, 90, 61,0.1);}

          .ultra-desktop-search-dropdown::-webkit-scrollbar {
            width: 4px;}

          .ultra-desktop-search-dropdown::-webkit-scrollbar-track {
            background: rgba(45, 90, 61,0.1);border-radius: 10px;}

          .ultra-desktop-search-dropdown::-webkit-scrollbar-thumb {
            background: #2D5A3D !important;border-radius: 10px;}

          .ultra-desktop-search-dropdown::-webkit-scrollbar-thumb:hover {
            background: #1B4332 !important;}

          .ultra-desktop-search-dropdown.active {
            opacity: 1;visibility: visible;transform: translateY(0);}

          .ultra-desktop-search-content {
            padding: 0;}

          .ultra-desktop-search-loading {
            display: flex;align-items: center;justify-content: center;padding: 30px;gap: 10px;color: #6c757d;}

          .ultra-desktop-loading-spinner {
            width: 20px;height: 20px;border: 2px solid rgba(45, 90, 61,0.1);border-top-color: #2D5A3D;border-radius: 50%;animation: ultra-desktop-spin 1s linear infinite;}

          @keyframes ultra-desktop-spin {
            to { transform: rotate(360deg);}
          }

          .ultra-desktop-search-header {
            padding: 15px 20px;background: white !important;border-bottom: 1px solid #D9D2C5;border-radius: 14px 14px 0 0;position: relative;box-shadow: 0 2px 8px rgba(0,0,0,0.02);}

          .ultra-desktop-search-title {
            display: flex;align-items: center;gap: 5px;font-family: 'Jost',sans-serif;color: #2c3e50 !important;}

          .ultra-desktop-search-count {
            font-weight: 600;font-size: 16px;color: #2c3e50 !important;}

          .ultra-desktop-search-query {
            opacity: 0.7;font-size: 14px;color: #6c757d !important;}

          .ultra-desktop-search-breakdown {
            display: flex;gap: 15px;margin-top: 8px;}

          .ultra-desktop-breakdown-item {
            display: flex;align-items: center;gap: 4px;font-size: 12px;color: #6c757d !important;}

          .ultra-desktop-breakdown-count {
            font-weight: 600;background: #F5F2EB !important;color: #495057 !important;padding: 2px 6px;border-radius: 10px;border: 1px solid #D9D2C5;}

          .ultra-desktop-search-results {
            padding: 10px;}

          .ultra-desktop-search-item {
            display: flex;flex-direction: column;gap: 0;padding: 0;border-radius: 12px;margin-bottom: 8px;background: white;border: 1px solid transparent;box-shadow: 0 2px 8px rgba(0,0,0,0.04);transition: all 0.3s ease;text-decoration: none;color: inherit;overflow: hidden;}

          .ultra-desktop-item-wrapper {
            display: flex;align-items: center;gap: 0;background: white;}

          .ultra-desktop-search-item:hover {
            border-color: #2D5A3D;transform: translateX(5px);box-shadow: 0 4px 12px rgba(0,0,0,0.08);}

          .ultra-desktop-item-image {
            width: 90px;height: 90px;border-radius: 8px;overflow: hidden;flex-shrink: 0;background: white;border: 1px solid #D9D2C5;position: relative;display: flex;align-items: center;justify-content: center;margin: 15px;margin-right: 0;}

          .ultra-desktop-item-image img {
            width: 100%;height: 100%;transition: transform 0.3s ease;}

          .ultra-desktop-item-image img[style*="contain"] {
            object-fit: contain !important;max-width: 100%;max-height: 100%;width: 100%;height: 100%;margin: auto;}

          .ultra-desktop-search-item:hover .ultra-desktop-item-image img {
            transform: scale(1.1);}

          .ultra-desktop-item-type-icon {
            position: absolute;top: 2px;right: 2px;font-size: 10px;}

          .ultra-desktop-item-content {
            flex: 1;min-width: 0;background: white;padding: 15px;height: 120px;display: flex;align-items: center;}

          .ultra-desktop-item-title {
            font-size: 14px;font-weight: 600;margin: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-family: 'Jost',sans-serif;color: #2c3e50;text-align: left;padding: 10px 15px;background: white;border-bottom: 1px solid rgba(0,0,0,0.08);}

          .ultra-desktop-item-status {
            padding: 10px 15px;background: white;border-top: 1px solid rgba(0,0,0,0.08);display: flex;align-items: center;gap: 8px;text-align: left;}

          .ultra-desktop-item-price {
            font-size: 14px;font-weight: 700;color: #2D5A3D;margin-bottom: 4px;font-family: 'Jost',sans-serif;}

          /* New price styling */
          .ultra-desktop-item-price-container {
            margin-bottom: 4px;background: #F5F2EB;border-radius: 12px;padding: 1rem 0.5rem;border: 1px solid rgba(224,224,224,0.5);min-height: 90px;display: flex;flex-direction: column;justify-content: center;width: 100%;}

          .ultra-desktop-price-label {
            display: inline-block !important;font-size: 0.6rem !important;color: #2e7d32 !important;font-weight: 700 !important;margin-bottom: 0.25rem !important;text-transform: uppercase !important;letter-spacing: 0.3px !important;background: #e8f5e9 !important;padding: 0.2rem 0.55rem !important;border-radius: 20px !important;border: none !important;font-family: 'Jost',sans-serif !important;}

          .ultra-desktop-price-main {
            display: flex !important;align-items: center !important;justify-content: center !important;gap: 6px !important;flex-wrap: wrap !important;}

          .ultra-desktop-price-current {
            font-size: 20px !important;font-weight: 800 !important;color: #2D5A3D !important;font-family: 'Jost',sans-serif !important;}

          .ultra-desktop-price-compare {
            font-size: 16px !important;color: #b2bec3 !important;text-decoration: line-through !important;font-weight: 500 !important;}

          .ultra-desktop-price-discount {
            background: #E12D2D !important;color: white !important;font-size: 11px !important;padding: 4px 8px 4px 14px !important;border-radius: 0 3px 3px 0 !important;clip-path: polygon(8px 0,100% 0,100% 100%,8px 100%,0 50%) !important;-webkit-clip-path: polygon(8px 0,100% 0,100% 100%,8px 100%,0 50%) !important;-webkit-mask: radial-gradient(circle 3.5px at 6px 50%,transparent 75%,rgba(0,0,0,0.2) 85%,rgba(0,0,0,0.6) 92%,black 100%) 85%,rgba(0,0,0,0.6) 92%,black 100%) 96%,black 100%) !important;mask: radial-gradient(circle 3.5px at 6px 50%,transparent 75%,rgba(0,0,0,0.2) 85%,rgba(0,0,0,0.6) 92%,black 100%) 96%,black 100%) !important;font-weight: 700 !important;text-transform: uppercase !important;letter-spacing: 0.5px !important;}

          .ultra-desktop-item-meta {
            display: flex;align-items: center;gap: 8px;font-size: 11px;color: #6c757d;}

          .ultra-desktop-item-type {
            font-weight: 600;color: #2c3e50;}

          .ultra-desktop-item-badge {
            background: #2D5A3D !important;color: white !important;font-size: 9px !important;padding: 2px 6px !important;border-radius: 10px !important;font-weight: 600 !important;text-transform: uppercase !important;letter-spacing: 0.3px !important;display: inline-block !important;margin-top: 4px !important;}

          .ultra-desktop-item-badge.unavailable {
            background: #dc3545 !important;}

          .ultra-desktop-item-badge.type-collection {
            background: #2D5A3D !important;}

          .ultra-desktop-item-badge.type-page {
            background: #2D5A3D !important;}

          .ultra-desktop-item-badge.type-article {
            background: #2D5A3D !important;}

          .ultra-desktop-search-footer {
            padding: 15px 20px;border-top: 1px solid #D9D2C5;background: #F5F2EB;border-radius: 0 0 14px 14px;display: flex;justify-content: center;align-items: center;}

          .ultra-desktop-search-view-all {
            display: inline-flex !important;align-items: center;justify-content: center;gap: 0.75rem;width: auto;max-width: 280px;margin: 0 auto;padding: 0.875rem 2rem !important;background: white !important;color: #2D5A3D !important;border: 2px solid #2D5A3D !important;border-radius: 20px !important;text-decoration: none !important;font-family: 'Jost',sans-serif !important;font-weight: 600 !important;font-size: 16px !important;transition: all 0.3s cubic-bezier(0.4,0,0.2,1) !important;box-shadow: 0 2px 10px rgba(45, 90, 61,0.1) !important;text-align: center;}

          .ultra-desktop-search-view-all:hover {
            background: #2D5A3D !important;color: white !important;transform: translateY(-2px) !important;box-shadow: 0 4px 15px rgba(45, 90, 61,0.25) !important;}

          .ultra-desktop-search-empty {
            display: flex;flex-direction: column;align-items: center;justify-content: center;padding: 40px 20px;text-align: center;}

          .ultra-desktop-empty-icon {
            font-size: 32px;margin-bottom: 10px;opacity: 0.5;}

          .ultra-desktop-empty-text {
            font-size: 14px;color: #6c757d;font-family: 'Jost',sans-serif;}

          /* Desktop Tabs Styles */
          .ultra-desktop-search-tabs {
            display: flex;background: white;border-bottom: 1px solid #D9D2C5;padding: 0 10px;gap: 4px;overflow-x: auto;scrollbar-width: none;-ms-overflow-style: none;}

          .ultra-desktop-search-tabs::-webkit-scrollbar {
            display: none;}

          .ultra-desktop-search-tab {
            display: flex;align-items: center;gap: 6px;padding: 12px 20px;background: transparent;border: none;border-bottom: 2px solid transparent;color: #6c757d;font-family: 'Jost',sans-serif;font-size: 14px;font-weight: 600;cursor: pointer;transition: all 0.3s ease;white-space: nowrap;position: relative;}

          .ultra-desktop-search-tab:hover {
            color: #495057;background: rgba(45, 90, 61,0.05);}

          .ultra-desktop-search-tab.active {
            color: #2D5A3D;border-bottom-color: #2D5A3D;background: rgba(45, 90, 61,0.08);}

          .ultra-desktop-tab-count {
            background: #F5F2EB;color: #6c757d;padding: 2px 8px;border-radius: 12px;font-size: 11px;font-weight: 700;min-width: 20px;text-align: center;}

          .ultra-desktop-search-tab.active .ultra-desktop-tab-count {
            background: #2D5A3D;color: white;}

          .ultra-desktop-tab-content {
            display: none;}

          .ultra-desktop-tab-content.active {
            display: block;}

          .ultra-desktop-no-results {
            padding: 30px;text-align: center;color: #6c757d;font-size: 14px;font-family: 'Jost',sans-serif;}

          /* Responsive adjustments */
          @media (max-width: 768px) {
            .ultra-desktop-search-dropdown {
              display: none !important;}
          }

          /* FIX BOLD GLOBALE PER PREZZI E IVA SU DESKTOP IN TUTTE LE PAGINE */

          /* Media query solo per desktop */
          @media (min-width: 769px) {
            /* Forza il bold su tutti i prezzi desktop */
            .ultra-desktop-price-current,.ultra-desktop-price-current *,[class*="desktop-price"],[class*="desktop-price"] * {
              font-weight: 800 !important;}

            /* Forza font-weight consistente su tutte le etichette prezzo desktop */
            .ultra-desktop-price-label,[class*="desktop-price-label"],.ultra-mobile-price-label {
              font-weight: 700 !important;font-size: 0.6rem !important;color: #2e7d32 !important;background: #e8f5e9 !important;border: none !important;border-radius: 20px !important;}

            /* Fix per tutti gli span IVA con font-weight inline */
            span[style*="font-weight: 700"],span[style*="font-weight: 600"],span[style*="font-weight: 500"] {
              font-weight: 800 !important;}

            /* Fix specifico per IVA nei prezzi - mantieni stile consistente */
            .ultra-desktop-price-current span[style*="IVA"],.ultra-mobile-price-current span[style*="IVA"],[class*="price"] span[style*="IVA"] {
              font-weight: 700 !important;font-size: 0.5em !important;color: #2D5A3D !important;margin-left: 0.2rem !important;vertical-align: super !important;}

            /* Assicura bold nei risultati ricerca desktop */
            .ultra-desktop-search-dropdown .ultra-desktop-search-item .ultra-desktop-price-current,.ultra-desktop-search-dropdown .ultra-desktop-search-item .ultra-desktop-price-current * {
              font-weight: 800 !important;}

            .ultra-desktop-search-dropdown .ultra-desktop-search-item .ultra-desktop-price-label {
              font-weight: 700 !important;color: #2e7d32 !important;background: #e8f5e9 !important;border: none !important;}

            /* Fix per i prezzi in tutte le sezioni */
            .ultra-desktop-item-price-container .ultra-desktop-price-main .ultra-desktop-price-current,.ultra-desktop-item-price-container .ultra-desktop-price-main .ultra-desktop-price-current span {
              font-weight: 800 !important;}

            /* Mantieni compare price più leggero per differenziarlo */
            .ultra-desktop-price-compare {
              font-weight: 500 !important;}
          }

          /* SCROLLBAR PERSONALIZZATA - FINALE */
          ::-webkit-scrollbar:vertical {
            width: 20px !important;}

          ::-webkit-scrollbar:horizontal {
            display: none !important;height: 0 !important;width: 0 !important;}

          ::-webkit-scrollbar-track {
            background: rgba(45, 90, 61,0.1) !important;border-radius: 10px !important;}

          ::-webkit-scrollbar-thumb {
            background: #2D5A3D !important;border-radius: 10px !important;}

          ::-webkit-scrollbar-thumb:hover {
            background: #1B4332 !important;}

          html,body {
            scrollbar-width: auto !important;scrollbar-color: #2D5A3D rgba(45, 90, 61,0.1) !important;}
        /* OVERRIDE: Stile TAG per tutti i badge sconto */

    .fx-discount-badge,.ultra-mobile-price-discount,.ultra-desktop-price-discount,span.ultra-mobile-price-discount,span.ultra-desktop-price-discount {

        background: #E12D2D !important;color: white !important;font-family: 'Jost',sans-serif !important;font-size: 0.7rem !important;font-weight: 700 !important;padding: 0.25rem 0.5rem 0.25rem 0.9rem !important;border-radius: 0 3px 3px 0 !important;line-height: 1 !important;-webkit-mask: radial-gradient(circle 3.5px at 5px 50%,transparent 75%,rgba(0,0,0,0.2) 85%,rgba(0,0,0,0.6) 92%,black 100%) 85%,rgba(0,0,0,0.6) 92%,black 100%) 96%,black 100%) !important;mask: radial-gradient(circle 3.5px at 5px 50%,transparent 75%,rgba(0,0,0,0.2) 85%,rgba(0,0,0,0.6) 92%,black 100%) 96%,black 100%) !important;}

    </style>
      `;

      document.head.insertAdjacentHTML('beforeend', styles);
    }
  }

  // ======= 🚀 INIZIALIZZAZIONE COMPLETA ======= //
  async function initializeUltraSmartSearch() {

    // Attendi che il DOM sia completamente caricato, ma con timeout massimo
    let attempts = 0;
    while (document.body.classList.contains('homeup-show-loader') && attempts < 10) {
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }

    // Forza l'inizializzazione dopo 1 secondo anche se il loader è ancora presente

    // Inizializza il data manager
    const dataManager = new CompleteDataManager();
    await dataManager.initialize();

    // Inizializza l'UI premium
    const searchUI = new PremiumSearchUI(dataManager);

    // Espone le funzionalità globalmente
    window.ultraSmartSearch = {
      dataManager,
      searchUI,
      search: (query, options) => dataManager.searchEverything(query, options),
      openMobileModal: () => searchUI.openMobileModal(),
      closeMobileModal: () => searchUI.closeMobileModal(),
      reloadCollections: async () => {
        await dataManager.loadCollections();
        return dataManager.collections;
      },
      getCollections: () => dataManager.collections,
      testSearch: (query) => {
        const results = dataManager.searchCollections(query.toLowerCase());
        return results;
      }
    };

  }

  // Avvia l'inizializzazione
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeUltraSmartSearch);
  } else {
    initializeUltraSmartSearch();
  }

  // Fallback: forza inizializzazione dopo 2 secondi se non è già avvenuta
  setTimeout(() => {
    if (!window.ultraSmartSearch) {
      initializeUltraSmartSearch();
    }
  }, 2000);

})();